import { lazy } from "react";

export const importView = (name) => {
  return lazy(() => import(/* webpackChunkName: "pa-[request]" */ `modules/pa/views/${name}`));
};
